    
<!-- Main Dialog -->
<div class="job-details-dialog">
  <div class="dialog-header">
    <h2 class="dialog-title">Job Details</h2>
    <button mat-icon-button (click)="onClose()" class="close-btn" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <div class="table-wrapper">
      <div class="table-container">
        <!-- Main Table -->
        <table mat-table [dataSource]="dataSource" class="modern-table mat-elevation-z8">

          <!-- Job Number -->
          <ng-container matColumnDef="jobNumber">
            <th mat-header-cell *matHeaderCellDef>Job Number</th>
            <td mat-cell *matCellDef="let element" class="value-cell">{{ element.JOB_NO }}</td>
          </ng-container>

          <!-- Sensors -->
          <ng-container matColumnDef="sensors">
            <th mat-header-cell *matHeaderCellDef>Sensors</th>
            <td mat-cell *matCellDef="let element">
              <span class="sensor-count">{{ element.no_of_sensor }}</span>
            </td>
          </ng-container>

          <!-- Start Date -->
          <ng-container matColumnDef="startDate">
            <th mat-header-cell *matHeaderCellDef>Start Date</th>
            <td mat-cell *matCellDef="let element">
              {{ element.start_date | date:'yyyy-MM-dd HH:mm' }}
            </td>
          </ng-container>

          <!-- End Date -->
          <ng-container matColumnDef="endDate">
            <th mat-header-cell *matHeaderCellDef>End Date</th>
            <td mat-cell *matCellDef="let element">
              <span *ngIf="element.end_date">{{ element.end_date | date:'yyyy-MM-dd HH:mm' }}</span>
              <span *ngIf="!element.end_date" class="highlight-empty">Not Completed</span>
            </td>
          </ng-container>

          <!-- Megger Value -->
          <ng-container matColumnDef="meggerValue">
            <th mat-header-cell *matHeaderCellDef>Megger Value</th>
            <td mat-cell *matCellDef="let element" class="value-cell">{{ element.megger_value }}</td>
          </ng-container>

          <!-- PI Value -->
          <ng-container matColumnDef="piValue">
            <th mat-header-cell *matHeaderCellDef>PI Value</th>
            <td mat-cell *matCellDef="let element" class="value-cell">{{ element.PI_value }}</td>
          </ng-container>

          <!-- Sensor 1 -->
          <ng-container matColumnDef="sensorSerial1">
            <th mat-header-cell *matHeaderCellDef>Sensor 1 ID</th>
            <td mat-cell *matCellDef="let element">{{ element.sensor_serial_no_1 }}</td>
          </ng-container>

          <ng-container matColumnDef="sensorSerial1Value">
            <th mat-header-cell *matHeaderCellDef>Sensor 1 Val</th>
            <td mat-cell *matCellDef="let element">
              <span class="sensor-value">{{ element.sensor_serial_no_1_value || '-' }}</span>
            </td>
          </ng-container>

          <!-- Sensor 2 (Added Back) -->
          <ng-container matColumnDef="sensorSerial2">
            <th mat-header-cell *matHeaderCellDef>Sensor 2 ID</th>
            <td mat-cell *matCellDef="let element">
              <span *ngIf="element.sensor_serial_no_2">{{ element.sensor_serial_no_2 }}</span>
              <span *ngIf="!element.sensor_serial_no_2" class="highlight-empty">Not Used</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="sensorSerial2Value">
            <th mat-header-cell *matHeaderCellDef>Sensor 2 Val</th>
            <td mat-cell *matCellDef="let element">
              <span class="sensor-value">{{ element.sensor_serial_no_2_value || '-' }}</span>
            </td>
          </ng-container>

          <!-- Sensor 3 (Added Back) -->
          <ng-container matColumnDef="sensorSerial3">
            <th mat-header-cell *matHeaderCellDef>Sensor 3 ID</th>
            <td mat-cell *matCellDef="let element">
              <span *ngIf="element.sensor_serial_no_3">{{ element.sensor_serial_no_3 }}</span>
              <span *ngIf="!element.sensor_serial_no_3" class="highlight-empty">Not Used</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="sensorSerial3Value">
            <th mat-header-cell *matHeaderCellDef>Sensor 3 Val</th>
            <td mat-cell *matCellDef="let element">
              <span class="sensor-value">{{ element.sensor_serial_no_3_value || '-' }}</span>
            </td>
          </ng-container>

          <!-- Supervisor -->
          <ng-container matColumnDef="supervisor">
            <th mat-header-cell *matHeaderCellDef>Supervisor</th>
            <td mat-cell *matCellDef="let element">{{ element.supervisor_name }}</td>
          </ng-container>

          <!-- Status -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let element">
              <span class="status-badge" [ngClass]="element.status?.toLowerCase()">
                {{ element.status }}
              </span>
            </td>
          </ng-container>

          <!-- Records Button -->
          <ng-container matColumnDef="expand">
            <th mat-header-cell *matHeaderCellDef>Records</th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button color="primary" (click)="openMeasurementsDialog(element.JOB_NO)">
                <mat-icon>visibility</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>
  </div>
</div>

    
    
<!-- Measurements Popup Template -->
<ng-template #measurementsDialog>
  <div class="measurements-popup">
    
    <!-- Micro Header -->
    <div class="popup-header">
      <h3>Measurements</h3>
      <!-- Changed to Text Button -->
      <button mat-button mat-dialog-close class="close-popup-btn">
        Close
      </button>
    </div>

    <!-- Popup Content (Unchanged) -->
    <div class="popup-content">
      <div *ngIf="isLoadingMeasurements" class="loading">
        <mat-spinner diameter="30"></mat-spinner>
      </div>

      <div *ngIf="!isLoadingMeasurements && measurementsDataSource.length > 0" class="popup-table-container">
        <table class="measurements-table">
          <thead>
            <tr>
              <th>Megger Value</th>
              <th>PI Value</th>
              <th>Supervisor</th>
              <th>Date & Time</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let measurement of measurementsDataSource; let i = index"
                [ngClass]="{'alternate': i % 2 === 1}">
              <td>{{ measurement.megger_value }}</td>
              <td>{{ measurement.pi_value }}</td>
              <td>{{ measurement.supervisor_name }}</td>
              <td>{{ measurement.measured_at | date:'dd/MM/yyyy h:mm a' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="!isLoadingMeasurements && measurementsDataSource.length === 0" class="no-data">
        <p>No records found</p>
      </div>
    </div>
  </div>
</ng-template>

  

  